import React from 'react'

export const AddCircle = () => <path d='M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9C21,7,17,3,12,3z M12,17c-0.6,0-1-0.4-1-1v-3H8c-0.6,0-1-0.4-1-1s0.4-1,1-1h3V8c0-0.6,0.4-1,1-1s1,0.4,1,1v3h3c0.6,0,1,0.4,1,1s-0.4,1-1,1h-3v3C13,16.6,12.6,17,12,17z' />
